import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-partner-admin',
  templateUrl: './partner-admin.component.html',
  styleUrls: ['./partner-admin.component.css']
})
export class PartnerAdminComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
